module.exports = __webpack_public_path__ + "static/media/For Teachers_Icon.c6928ee4.png";